import styledComponents from 'styled-components';
import util from 'util';

import React from 'react';
import {
  MAX_CONTENT_WIDTH,
  DEFAULT_BLOCK_PADDING,
  HAIRLINE_COLOR,
} from './styleConstants';

export default styledComponents.section`
  max-width: ${MAX_CONTENT_WIDTH}
  display: flex;
  flex-direction: row;
  justify-content: ${({mid}) => mid ? 'center' : 'flex-end'};
  border-top: ${({ line, noLine }) => (noLine || (line === false) ? 'none' : `1px solid ${HAIRLINE_COLOR}`)};
  padding: ${(props) => {
    if (props.compact) return 0;
    return DEFAULT_BLOCK_PADDING;
  }};
  `;
